import * as React from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Banner, PageContainer, PageHeader } from "../components";
import { usePermission, useUser } from "../account/AccountStore";
import { Permissions } from "../account/permissions";
import { Tabs } from "../components/Tabs";
import MarkImportSetup from "./MarkImportSetup";
import MarkImportHistory from "./MarkImportHistory";

export default function MarkImports() {
  const location = useLocation();
  const navigate = useNavigate();
  const user = useUser();
  const canReadMarks = usePermission(Permissions.MARKS_READ);
  const canConnect = usePermission(Permissions.CONFIGURATION_READ);
  const connecting = location.pathname.endsWith("/connect");

  if (!connecting && !canReadMarks && canConnect) {
    return <Navigate to={`/mark-imports/connect${location.search}`} replace />;
  }

  return (
    <PageContainer className="space-y-5">
      <PageHeader
        title="Mark imports"
        icon={["fad", "file-import"]}
        description="See marks received from other applications, or find the assessment an application should send to."
      />
      <p className="text-sm text-text-weak">
        Organisation: {user.organization?.name ?? user.organization?.id}
      </p>
      <Tabs
        active={connecting ? "connect" : "history"}
        tabs={[
          { key: "history", label: "Import history", visible: canReadMarks },
          {
            key: "connect",
            label: "Connect an application",
            visible: canConnect,
          },
        ]}
        onChange={(key) =>
          navigate(
            key === "connect" ? "/mark-imports/connect" : "/mark-imports",
          )
        }
      />
      {connecting ? (
        canConnect ? (
          <MarkImportSetup />
        ) : (
          <Banner>
            Configuration read permission is required to select a target.
          </Banner>
        )
      ) : canReadMarks ? (
        <MarkImportHistory key={user.organization?.id} />
      ) : (
        <Banner>
          Marks read permission is required to view received imports.
        </Banner>
      )}
    </PageContainer>
  );
}
